import React from "react";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Outlet } from "react-router-dom";

export function AdminLayout() {
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("currentUser");
    window.location.reload();
  };

  return (
    <div className="admin-panel-layout">
      <div className="sidebar">
        <Sidebar />
      </div>

      <div className="main-content">
        <Header onLogout={handleLogout} />
        <div className="content-area p-3">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
